import { Tag } from '@cian/components';
import * as React from 'react';

import { ESuburbanWCType } from '../../../../json_query';
import { ISuburbanWCTypeTag } from '../../../state/tags/definitions/suburban_wc';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface ISuburbanWCTypeTagItemProps {
  tag: ISuburbanWCTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const suburbanWCTypeMap = {
  [ESuburbanWCType.Inside]: 'в доме',
  [ESuburbanWCType.Outside]: 'на улице',
};

export const SuburbanWCTypeTagItem = ({ tag, onDeleteClick, withNewTag }: ISuburbanWCTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  if (tag.value === ESuburbanWCType.Any) {
    return null;
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Санузел {suburbanWCTypeMap[tag.value]}
    </TagComponent>
  );
};
